import React from 'react';
import PropTypes from 'prop-types';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import './Filter.scss';

const buildOptions = filter => (result, item) => {
  if (item.filter !== filter) {
    return result;
  }
  result.push(
    <option
      key={item.id}
      value={item.id}
      disabled={item.disabled === true}
      hidden={item.hidden === true}>
      {item.label}
    </option>
  );
  return result;
};

const Filter = props => (
  <section className="product-filter">
    <div className="container-guttered">
      <div className="product-filter-wrapper">
        <div className="product-filter-column product-filter-column--title">
          <h3 className="text-giga">{props.filter.title}</h3>
        </div>
        <div className="product-filter-column product-filter-column--filters">
          <div>
            <label htmlFor="ages">{props.filter.ageLabel}</label>
            <select name="ages" id="ages" onChange={props.onHandleChange} value={props.values.ages}>
              {props.filterOptions.reduce(buildOptions('ages'), [])}
            </select>
          </div>
          <div>
            <label htmlFor="occasions">{props.filter.occasionsLabel}</label>
            <select name="occasions" id="occasions" onChange={props.onHandleChange} value={props.values.occasions}>
              {props.filterOptions.reduce(buildOptions('occasions'), [])}
            </select>
          </div>
        </div>
        <div className="product-filter-column product-filter-column--order">
          <div>
            <label htmlFor="order">{props.filter.orderLabel}</label>
            <select name="order" id="order" onChange={props.onHandleChange} value={props.values.order}>
              {props.filterOptions.reduce(buildOptions('order'), [])}
            </select>
          </div>
        </div>
      </div>
      <div className="product-filter-controls">
        <div>
          <div>
            <label htmlFor="order-mobile">{props.filter.orderLabel}</label>
            <select
              name="order"
              id="order-mobile"
              onChange={props.onHandleChange}
              value={props.values.order}>
              {props.filterOptions.reduce(buildOptions('order'), [])}
            </select>
          </div>
        </div>
        <div>
          <p>{replaceTextWithValues(props.filter.itemsShowing, { itemsVisible: props.itemsVisible })}</p>
        </div>
      </div>
    </div>
  </section>
);

Filter.propTypes = {
  filter: PropTypes.shape({
    title: PropTypes.string.isRequired,
    ageLabel: PropTypes.string.isRequired,
    occasionsLabel: PropTypes.string.isRequired,
    orderLabel: PropTypes.string.isRequired,
    itemsShowing: PropTypes.string.isRequired,
  }),
  itemsVisible: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  onHandleChange: PropTypes.func.isRequired,
  filterOptions: PropTypes.arrayOf(PropTypes.shape({
    filer: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
  })),
  values: PropTypes.shape({
    ages: PropTypes.string,
    occasions: PropTypes.string,
    order: PropTypes.string,
  })
};

export default Filter;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductList/Filter/Filter.js